import { Component, ViewEncapsulation } from "@angular/core";

import {
  TableRowEmptyStateComponent,
} from "../../../../shared/component/table-row-empty-state/table-row-empty-state.component";

@Component({
  selector: 'app-bm-loading-table',
  templateUrl: './bm-loading-table.component.html',
  styleUrls: ['./bm-loading-table.component.scss'],
  standalone: true,
  imports: [
    TableRowEmptyStateComponent,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class BmLoadingTableComponent {}
